import React, { createContext, useContext, useEffect, useState } from "react";
import { toClass } from "./index";
import "./dialog.css";
var DialogContextImpl = /** @class */ (function () {
    function DialogContextImpl() {
        this.listeners = [];
    }
    DialogContextImpl.prototype.hide = function () {
        this.listeners.forEach(function (cb) { return cb(null, false); });
    };
    DialogContextImpl.prototype.on_change = function (cb) {
        this.listeners.push(cb);
    };
    DialogContextImpl.prototype.show = function (view) {
        this.listeners.forEach(function (cb) { return cb(view, true); });
    };
    return DialogContextImpl;
}());
export { DialogContextImpl };
export var sampleDialogContext = new DialogContextImpl();
export var DialogContext = createContext(sampleDialogContext);
export function DialogContainer() {
    var dm = useContext(DialogContext);
    // @ts-ignore
    var _a = useState(null), content = _a[0], set_content = _a[1];
    useEffect(function () {
        dm.on_change(function (v) {
            set_content(v);
        });
    });
    return React.createElement("div", { className: toClass({
            dialogWrapper: true,
            visible: content !== null,
        }) }, content ? content : "no content");
}
